export default __webpack_public_path__ + "locales/hy-AM/EmptyTrashDialog.json?hash=6c5680a6a8b453a0e23489f72e1416fd";